import React from 'react';
import About from './AboutSection';
import CallUs from './CallUsSection';
import Service from './ServiceSection';
import Process from './ProcessSection';
import Testimonial from './TestimonialSection';
import Project from '../../components/Project';
import ScrollToTop from '../../components/Common/ScrollTop';
import BannerDefault from '../../components/Banner/BannerDefault';
import ServiceFlip from './ServiceSectionFlip';
import Brand from '../../components/Common/Brand'
import CounterStyleThree from '../../components/Elements/Counter/CounterStyleThree';

const HomeMain = () => {
	return (
		<React.Fragment>
			{/* banner-start */}
			<BannerDefault />
			{/* banner-start */}
			
			{/* services-area-start */}
			<Service />
			{/* services-area-end */}

			{/* about-area-start */}
			<About />
			{/* about-area-end */}
			
			{/* ServiceFlip-area-start */}
			<ServiceFlip /> 
			{/* ServiceFlip-area-end */}

			{/* call us section start */}
			<CallUs />
			{/* call us section end */}
			
			{/* process-area-start */}
			<Process />
			{/* process-area-end */}

			{/* project-area-start */}
			<Project />
			{/* project-area-end */}

			{/* Testimonial-area-start */}
			<Testimonial />
			{/* Testimonial-area-end */}

			{/* Counter Section Start */}
            <CounterStyleThree />
            {/* Counter Section Start */}

            {/* brand-area-start */}
            <Brand />
            {/* brand-area-end */}
			
			{/* scrolltop-start */}
			<ScrollToTop />
			{/* scrolltop-end */}
		</React.Fragment>
	);
}

export default HomeMain;